import z from 'zod';

/** Coerce BSON / Mongoose ObjectId (and similar) to hex string for Zod output validation. */
const objectIdInputToString = (val: unknown): unknown => {
  if (typeof val === 'string') {
    return val;
  }
  if (
    val !== null &&
    typeof val === 'object' &&
    'toHexString' in val &&
    typeof (val as { toHexString: unknown }).toHexString === 'function'
  ) {
    return (val as { toHexString: () => string }).toHexString();
  }
  return val;
};

const validateHexString = (string: string): boolean => {
  if (string?.length !== 24) return false;
  for (let i = 0; i < 24; i++) {
    const char = string.charCodeAt(i);
    if (
      // Check for ASCII 0-9
      (char >= 48 && char <= 57) ||
      // Check for ASCII a-f
      (char >= 97 && char <= 102) ||
      // Check for ASCII A-F
      (char >= 65 && char <= 70)
    ) {
      continue;
    }
    return false;
  }
  return true;
};

export const isValidObjectId = (id: string): boolean => {
  if (id === undefined || id === null) return false;
  if (typeof id === 'string') return validateHexString(id);
  return false;
};

export const ObjectIdSchema = z.preprocess(
  objectIdInputToString,
  z
    .string()
    .min(24)
    .max(32)
    .refine((val) => isValidObjectId(val)),
);
